import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { SO_CONG_CU } from "../data/tools.js";

/**
 * Khung động ở đầu trang chủ: câu hỏi nhà đầu tư sẽ hỏi → đi qua bộ công cụ →
 * thành một dòng trong hồ sơ gọi vốn. Lặp lại liên tục.
 *
 * Năm dòng theo đúng thứ tự 5 trạm trong lo-trinh.js (câu hỏi rút gọn cho vừa
 * thẻ). Kết quả là SỐ VÍ DỤ CỐ ĐỊNH, không phải số liệu của người xem.
 *
 * Ba trạng thái dòng giống bản đồ 5 trạm: có (nét liền) · đang làm · chưa có.
 * HTML prerender là trạng thái 0/5, đọc được trọn vẹn khi chưa có JavaScript.
 * Người bật "giảm chuyển động" thấy trạng thái đứng yên 3/5.
 *
 * Mỗi lúc chỉ hiện MỘT câu hỏi (câu đang trả lời), rồi nó bay vào lõi.
 * Chiều cao giữ cố định trong suốt vòng chạy (khoảng 460px) để vừa màn hình
 * laptop: nhãn "Hồ sơ gọi vốn của bạn" và nút ở chân khung không bị đẩy xuống.
 * cta (tuỳ chọn): { to, nhan } — nút ở chân khung, sáng lên khi hồ sơ đủ 5/5.
 */
const BUOC = [
  { hoi: "Còn bao lâu thì hết tiền?", ten: "Runway và vốn cần gọi", kq: "11 tháng · 4,2 tỷ" },
  { hoi: "Mô hình kinh doanh có đứng được không?", ten: "Mô hình tài chính", kq: "Đã soát giả định" },
  { hoi: "Ai sở hữu bao nhiêu sau vòng?", ten: "Cap table sau vòng", kq: "Founder 72%" },
  { hoi: "Deck đã đủ thuyết phục chưa?", ten: "Pitch deck", kq: "7/10 điểm" },
  { hoi: "Gửi cho quỹ nào?", ten: "Danh sách quỹ phù hợp", kq: "6 quỹ khớp" },
];
const N = BUOC.length;

export default function HoSoDong({ cta }) {
  const [buoc, setBuoc] = useState(0);
  const [bay, setBay] = useState(-1); // câu hỏi đang bay vào lõi
  const [nhip, setNhip] = useState(0); // đổi key để lõi nháy lại
  const [vong, setVong] = useState(0); // đổi key để các câu hỏi hiện lại khi lặp
  const hen = useRef([]);

  useEffect(() => {
    const sau = (ms, f) => hen.current.push(setTimeout(f, ms));
    const huy = () => { hen.current.forEach(clearTimeout); hen.current = []; };
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      setBuoc(3);
      return huy;
    }
    let b = 0;
    const chay = () => {
      if (document.hidden) { sau(1000, chay); return; }
      if (b >= N) {
        sau(3600, () => { b = 0; setBuoc(0); setBay(-1); setVong((v) => v + 1); sau(900, chay); });
        return;
      }
      sau(1100, () => setBay(b));
      sau(1950, () => { b += 1; setBuoc(b); setBay(-1); setNhip((n) => n + 1); sau(500, chay); });
    };
    sau(700, chay);
    return huy;
  }, []);

  const du = buoc >= N;
  return (
    <div className={`hsd${du ? " du" : ""}`}>
      <div className="hsd-dau" aria-hidden="true">Câu hỏi nhà đầu tư sẽ hỏi</div>
      <div className="hsd-hoi" key={vong} aria-hidden="true">
        {BUOC.map((b, i) => (
          <span
            key={b.hoi}
            className={`hsd-cau${i < buoc ? " xong" : i === bay ? " bay" : i === buoc ? " dang" : ""}`}
          >
            <i>?</i>{b.hoi}
          </span>
        ))}
        {du && <span className="hsd-xong-het">Đã trả lời đủ 5 câu hỏi</span>}
      </div>
      <div className={`hsd-loi${nhip ? " nhan" : ""}`} key={`n${nhip}`} aria-hidden="true">
        <span className="hsd-loi-tron">f</span>
        <span className="hsd-loi-ten">{SO_CONG_CU} công cụ</span>
      </div>
      <div className="hsd-nhan-ho-so">
        <span>{du ? "Hồ sơ sẵn sàng gửi quỹ" : "Hồ sơ gọi vốn của bạn"}</span>
        <span className="hsd-dem" aria-hidden="true">{Math.min(buoc, N)}/{N}</span>
      </div>
      <ol className="hsd-ho-so" aria-label="Ví dụ một bộ hồ sơ gọi vốn">
        {BUOC.map((b, i) => {
          const tt = i < buoc ? "da-co" : i === buoc ? "dang" : "";
          return (
            <li key={b.ten} className={`hsd-dong ${tt}${i === buoc - 1 && nhip ? " moi" : ""}`}>
              <span className="hsd-tick" aria-hidden="true">✓</span>
              <span className="hsd-ten">{b.ten}</span>
              <span className="hsd-kq">{tt === "da-co" ? b.kq : tt === "dang" ? "Đang làm" : "Chưa có"}</span>
            </li>
          );
        })}
      </ol>
      <div className="hsd-chan">
        {cta ? (
          <Link className="hsd-cta" to={cta.to}>{cta.nhan} <span aria-hidden="true">→</span></Link>
        ) : (
          <span className="hsd-chan-chu">Ví dụ minh hoạ · số liệu của bạn sẽ khác</span>
        )}
      </div>
    </div>
  );
}
